import React, { useState, useRef, useMemo, memo, useEffect } from 'react';
import { AddRole, UpdateRole, GetRoleDetails, GetPagesLookup, GetRolesPrivilegesByRoleID } from '../../../api/endpoints'
import Table from '../../../components/tableDrawer/TableItems/table';
import InputField from '../../../components/formFields/InputField';
import useForm from '../../../hooks/useForm';
import { LoadListDefault, useGet, usePost, useUpdate } from '../../../api/hooks';
import PopupContainer from '../../../components/popup';
import { MLInputField } from '@/components/Exporter';

const modalName = "CURoleModal"

const CURole = ({ roleID, modalID, loadData }) => {

    const loadedData = useRef(false)

    const { onSubmit, formHandler, onReset } = useForm()

    const { onUpdate } = useUpdate(UpdateRole)

    const { onPost } = usePost(AddRole)


    const { result: roleInfo, isPending } = useGet({
        ...LoadListDefault,
        params: [roleID],
        allowFetch: !!roleID,
        endPoint: GetRoleDetails
    })
    const { result: RolePrev, isPending: isRolePrevPending } = useGet({
        ...LoadListDefault,
        params: [roleID],
        defaultValue: [],
        allowFetch: !!roleID,
        endPoint: GetRolesPrivilegesByRoleID
    })

    const { result: pages, totalCount } = useGet({
        ...LoadListDefault,
        params: [],
        defaultValue: [],
        depArr: [loadData],
        allowFetch: true,
        endPoint: GetPagesLookup
    })



    const [RolePrivileges, setRolePrivileges] = useState([])


    useEffect(() => setRolePrivileges(RolePrev), [RolePrev])

    const removePagePriviledges = (PageCurrentPriviliges, action) => {
        for (const [key, value] of Object.entries(PageCurrentPriviliges)) {
            if (value && key != action && key != 'controllerNameID') {
                return false
            }
        }
        return true
    }

    const checked = (controllerNameID, Action) => {
        let RowPrivileges = RolePrivileges.find(ele => ele.controllerNameID == controllerNameID)
        if (!RowPrivileges)
            return false

        return RowPrivileges[Action]
    }


    const handleDisabled = (controllerNameID) => {
        let RowPrivileges = RolePrivileges.find(ele => ele.controllerNameID == controllerNameID) || {}
        let isGetChecked = false

        for (const [key, value] of Object.entries(RowPrivileges)) {
            if (value && key != 'canGet' && key != 'controllerNameID' && key != 'roleID') {
                isGetChecked = true
                break;
            }
        }
        return isGetChecked
    }

    const handleCheckboxChange = (e, controllerNameID, Action) => {
        let tempScreenObj = RolePrivileges.find(ele => ele.controllerNameID === controllerNameID) || {}
        let filteredArr = RolePrivileges.filter(ele => ele.controllerNameID !== controllerNameID)

        tempScreenObj[Action] = e.target.checked
        tempScreenObj.controllerNameID = controllerNameID
        // tempScreenObj.role = roleID

        if (e.target.checked) {
            tempScreenObj.canGet = true
        }

        if (!e.target.checked && removePagePriviledges(tempScreenObj, Action)) {
            setRolePrivileges([...filteredArr])
            return
        }

        filteredArr.push(tempScreenObj)
        setRolePrivileges([...filteredArr])
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'label',
            },
            {
                Header: 'Read',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <input type="checkbox" name="read" disabled={handleDisabled(original.value)} checked={checked(original.value, 'canGet')} onChange={(e) => handleCheckboxChange(e, original.value, 'canGet')} />
                        </>
                    )
                }
            },
            {
                Header: 'Write',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <input type="checkbox" name="write" checked={checked(original.value, 'canAdd')} onChange={(e) => handleCheckboxChange(e, original.value, 'canAdd')} />
                        </>
                    )
                }
            },
            {
                Header: 'Edit',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <input type="checkbox" name="edit" checked={checked(original.value, 'canEdit')} onChange={(e) => handleCheckboxChange(e, original.value, 'canEdit')} />
                        </>
                    )
                }
            },
            {
                Header: 'Delete',
                Cell: ({ row: { original } }) => {
                    return (
                        <>
                            <input type="checkbox" name="delete" checked={checked(original.value, 'canDelete')} onChange={(e) => handleCheckboxChange(e, original.value, 'canDelete')} />
                        </>
                    )
                }
            }
        ], [RolePrivileges]

    )

    const onApply = () => roleID ? onSubmit(data => onUpdate(roleID, { name: data.RoleName, nameEN: data.RoleNameEn, rolesPriviledges: RolePrivileges }, () => modalID.current.click())) : onSubmit(data => onPost({ name: data.RoleName, nameEN: data.RoleNameEn, rolesPriviledges: RolePrivileges }, () => modalID.current.click())).then(() => setRolePrivileges([])).then(() => modalID.current.click())


    return (
        <PopupContainer
            name={`${modalName}_${roleID}`}
            recordID={roleID}
            title={roleID ? "edit-role" : "add-role"}
            onApply={onApply}
            resetAllFields={onReset}
            modalID={modalID}
            btnName={roleID ? "Update" : "Save"}
        >
            <MLInputField formHandler={formHandler}  name={"RoleName"} defaultValue={roleInfo} isLoading={isPending} />

            <div className='w-100'>
                <Table
                    columns={columns}
                    data={pages}
                    TotalRows={totalCount}
                    isNeedFetch={false}
                    isPagination={false}
                />
            </div>

        </PopupContainer>
    );
}

export default memo(CURole);
